/* PAPAPATTES (WF16-JS) : masque le sélecteur d'une option redondante.
   Cas : option 1 « Rose - S » + option 2 « S ». Une option B est redondante si, pour TOUTES les variantes,
   la valeur d'une autre option A contient la valeur de B comme segment (« - »), ou se termine / commence par elle (comparaison sans espaces,
   ponctuation ni casse). On masque alors le sélecteur de B ; ses boutons restent cochés (envoi du formulaire intact).
   Sécurité : si le motif n'est pas vérifié sur 100 % des variantes, rien n'est masqué. */
(function () {
  if (window.__ppVarRedundant) return;
  window.__ppVarRedundant = true;
  function norm(s) { return String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9À-ɏ]+/g, ''); }
  function distinct(list, k) { var o = {}; list.forEach(function (v) { o[v.options[k]] = 1; }); return Object.keys(o).length; }
  function redundant(data) {
    var vs = data.variants, n = data.names.length, out = [];
    if (n < 2 || !vs.length) return out;
    for (var b = 0; b < n; b++) {
      for (var a = 0; a < n; a++) {
        if (a === b) continue;
        var da = distinct(vs, a), db = distinct(vs, b);
        if (db > da || (db === da && b < a)) continue; /* B garde au plus autant de valeurs que A ; à égalité on masque le dernier */
        var okEnd = true, okStart = true;
        for (var i = 0; i < vs.length; i++) {
          var x = norm(vs[i].options[a]), y = norm(vs[i].options[b]);
          if (!y || x === y) { okEnd = okStart = false; break; } /* valeurs identiques = option complète, pas un doublon collé */
          var tok = String(vs[i].options[a]).split(/\s*-\s*/).some(function (t) { return norm(t) === y; });
          if (!tok && x.slice(-y.length) !== y) okEnd = false;
          if (!tok && x.slice(0, y.length) !== y) okStart = false;
          if (tok) continue;
          if (!okEnd && !okStart) break;
        }
        if (okEnd || okStart) { out.push(b); break; }
      }
    }
    /* garde-fou : au moins une option reste visible */
    return out.length >= n ? out.slice(0, n - 1) : out;
  }
  function apply(root) {
    (root || document).querySelectorAll('variant-selects').forEach(function (vs) {
      var js = vs.querySelector('script[data-pp-variants]');
      if (!js) return;
      var data; try { data = JSON.parse(js.textContent); } catch (e) { return; }
      var hide = redundant(data);
      if (!hide.length) return;
      var fields = vs.querySelectorAll('fieldset.product-form__input, div.product-form__input--dropdown');
      hide.forEach(function (k) {
        var name = data.names[k];
        Array.prototype.forEach.call(fields, function (f) {
          var r = f.querySelector('input[data-option-name], select');
          var nm = r && (r.dataset && r.dataset.optionName || (r.name || '').replace(/^options\[|\]$/g, ''));
          if (nm === name && !f.hasAttribute('data-pp-redundant')) {
            f.setAttribute('data-pp-redundant', '1');
            f.style.display = 'none';
          }
        });
      });
    });
  }
  function run() { apply(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
})();
